function r(e) {
  const t = `${e}`;
  return t ? t[0].toUpperCase() + t.slice(1) : "";
}
export {
  r as capitalize
};
//# sourceMappingURL=capitalize.es.js.map
